import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { pluck, map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import * as i2 from 'ng2-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';

class FbLeavePolicyService {
    constructor(http) {
        this.http = http;
    }
    getLeavePolicy(companyId) {
        return this.http.get(`/vd/formBuilder/lms/get/policyDocuments/company/${companyId}?companyId=${companyId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
}
FbLeavePolicyService.ɵfac = function FbLeavePolicyService_Factory(t) { return new (t || FbLeavePolicyService)(i0.ɵɵinject(i1.HttpClient)); };
FbLeavePolicyService.ɵprov = i0.ɵɵdefineInjectable({ token: FbLeavePolicyService, factory: FbLeavePolicyService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbLeavePolicyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class FbLeavePolicyComponent {
    constructor(fbLeavePolicyService) {
        this.fbLeavePolicyService = fbLeavePolicyService;
        this.showLoader = false;
        this.pdfSrc = null;
    }
    ngOnInit() {
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
        if (this.companyId) {
            this.getLeavePolicy();
        }
    }
    onProgress(progressData) {
        this.showLoader = true;
    }
    onComplete(i) {
        this.showLoader = false;
    }
    getLeavePolicy() {
        this.fbLeavePolicyService.getLeavePolicy(this.companyId).subscribe((response) => {
            if (response && response.path) {
                //const environmentDocs = `${environment.docs}`.replace(':5651/docs', '');
                const replacedPath = response.path.replace('/var/www/', '').replace(/^\//, '');
                this.pdfSrc = `${environment.appUrl}/${replacedPath}`;
            }
        });
    }
}
FbLeavePolicyComponent.ɵfac = function FbLeavePolicyComponent_Factory(t) { return new (t || FbLeavePolicyComponent)(i0.ɵɵdirectiveInject(FbLeavePolicyService)); };
FbLeavePolicyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FbLeavePolicyComponent, selectors: [["lib-fb-leave-policy"]], decls: 1, vars: 1, consts: [["useBrowserLocale", "true", 3, "src", "after-load-complete", "on-progress"]], template: function FbLeavePolicyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "pdf-viewer", 0);
        i0.ɵɵlistener("after-load-complete", function FbLeavePolicyComponent_Template_pdf_viewer_after_load_complete_0_listener($event) { return ctx.onComplete($event); })("on-progress", function FbLeavePolicyComponent_Template_pdf_viewer_on_progress_0_listener($event) { return ctx.onProgress($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("src", ctx.pdfSrc);
    } }, directives: [i2.PdfViewerComponent], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbLeavePolicyComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-leave-policy',
                templateUrl: 'fb-leave-policy.component.html',
                styleUrls: ['fb-leave-policy.component.scss']
            }]
    }], function () { return [{ type: FbLeavePolicyService }]; }, null); })();

class FbLeavePolicyModule {
}
FbLeavePolicyModule.ɵfac = function FbLeavePolicyModule_Factory(t) { return new (t || FbLeavePolicyModule)(); };
FbLeavePolicyModule.ɵmod = i0.ɵɵdefineNgModule({ type: FbLeavePolicyModule });
FbLeavePolicyModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FbLeavePolicyModule, { declarations: [FbLeavePolicyComponent], imports: [PdfViewerModule], exports: [FbLeavePolicyComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbLeavePolicyModule, [{
        type: NgModule,
        args: [{
                declarations: [FbLeavePolicyComponent],
                imports: [
                    PdfViewerModule
                ],
                exports: [FbLeavePolicyComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fb-leave-policy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FbLeavePolicyComponent, FbLeavePolicyModule, FbLeavePolicyService };
//# sourceMappingURL=fb-leave-policy.js.map
